import { ArrowRight } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';

/** Tooltip footer telling the user a chart bucket is clickable. */
export function ChartClickHint() {
  const { LL } = useI18nContext();
  return (
    <p className="flex items-center gap-1 text-xs font-medium text-primary">
      {LL.metricsPage.repurchaseDrilldown.chartClickHint()}
      <ArrowRight className="size-3" aria-hidden="true" />
    </p>
  );
}
